import { useState } from "react";
import StyledTable, { ColumnHeader } from "../../../components/table/styled-table";
import BiometricDeviceTableRow from "./biometric-device-table-row";
import { BiometricDevice } from "../../../service/model/biometric.model";
import { configs } from "../../../app/app-configs";
import { useAppSelector } from "../../../app/hooks";
import { selectIsLoading } from "../biometric-device.slice";

const headers: ColumnHeader[] = [
    { name: "Serial Number" },
    { name: "Device Name" },
    { name: "Model" },
    { name: "Actions", className: "action-header" }
]

interface TableProps {
    readonly devices: BiometricDevice[]
}

const BiometricDeviceTable: React.FC<TableProps> = ({ devices }) => {
    const isLoading = useAppSelector(selectIsLoading);
    const [page, setPage] = useState(1);

    const pageCount = Math.ceil(devices.length / configs.PAGE_SIZE);

    const handlePageChange = (selectedPage: number) => {
        setPage(selectedPage);
    }

    return (
        <StyledTable headers={headers}
            currentPage={page}
            totalPages={pageCount}
            loading={isLoading}
            emptyMessage="No biometric devices found"
            onPageChange={handlePageChange}>

            {devices?.slice((page - 1) * configs.PAGE_SIZE, page * configs.PAGE_SIZE).map(device =>
                <BiometricDeviceTableRow device={device} key={device.id} />
            )}
        </StyledTable>
    );
}

export default BiometricDeviceTable;